/**
 * Spec 06-test-cases.md W-T-97 — the old app rendered `9:42:` when the
 * device's navigator locale was `en-US` (12h clock, no leading zero, a
 * dangling `:` from a truncated seconds format). The ticket / note-card
 * clock always shows the same 2-digit 24h `HH:MM`, regardless of the
 * device's locale — so the `Intl.DateTimeFormat` locale is pinned to
 * `fr-FR` with an explicit `hourCycle: 'h23'` rather than left to inherit
 * `navigator.language`. The *timezone* is intentionally NOT pinned — a
 * waiter's device is physically at the restaurant, so its local timezone is
 * the display truth.
 *
 * Reused by both the ticket header (`ticket-time`, W-T-01) and the note-list
 * cards (`note-card-time`, W-L-05) — lives in `waiter/` so both callers
 * (NotesListPage in `waiter/`, TicketHeader in `waiterTicket/`) import it
 * without a cross-feature-folder dependency in either direction.
 */
const TICKET_TIME_FORMATTER = new Intl.DateTimeFormat('fr-FR', {
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
});

export function formatTicketTime(iso: string): string {
  return TICKET_TIME_FORMATTER.format(new Date(iso));
}
